import * as React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next"

import { DownloadButton } from "../button/download-button/DownloadButton"
import { Text } from "../Text/Text"

export const AppDownloadPromo = () => {
  const imageQuery = useStaticQuery(graphql`
  query AppDownloadPromo {
    appDownloadPromoImage: file(
      relativePath: { eq: "app-download-promo/img-calendar.png" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 269)
      }
      publicURL
    }
  }
`)

  const appDownloadPromoImage = getImage(imageQuery.appDownloadPromoImage)

  const { t } = useTranslation("shared", {
    keyPrefix: "app_download_promo",
  });

  return (
    <div className="max-w-content-width mx-auto py-8 md:py-16 px-5">
      <div className="grid md:gap-6 md:grid-cols-2">
        <div className="justify-self-center">
          <GatsbyImage
            alt="Appointment Booking Calendar"
            image={appDownloadPromoImage}
          />
        </div>
        <div className="text-left">
          <div className="mt-5 md:mt-0">
            <Text variant="medium-header">{t("title")}</Text>
          </div>
          <div className="mt-5">
            <Text variant="body">{t("intro")}</Text>
          </div>
          <div className="mt-5">
            <DownloadButton text={t("button_text")} href="/app/" variant="primary-button-sky" />
          </div>
        </div>
      </div>      
    </div>
  )
}
